import { render, staticRenderFns } from "./ActionNavigateTo.vue?vue&type=template&id=f5a6a5d2"
import script from "./ActionNavigateTo.vue?vue&type=script&lang=js"
export * from "./ActionNavigateTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports